import React from "react"
import { ReactComponent as BanIcon } from "images/icons/ban.svg"
import { formatOperation } from "../helpers"
import {
  BlockedContainer,
  BlockedDescription,
  BlockedIcon,
  BlockedTitle
} from "./BlockedTabPanel.styled"

type Props = {
  operation: string
  stateDescription?: string
}

const BlockedTabPanel = ({ operation, stateDescription }: Props) => (
  <BlockedContainer data-testid="blocked-tab-panel">
    <BlockedIcon>
      <BanIcon />
    </BlockedIcon>
    <BlockedTitle>{formatOperation(operation)} is blocked</BlockedTitle>
    <BlockedDescription>
      {stateDescription
        ? `Blocked by custom state: ${stateDescription}`
        : "Blocked by a custom state"}
    </BlockedDescription>
  </BlockedContainer>
)

export default BlockedTabPanel
